"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUploaderIcon = void 0;
var _react = _interopRequireDefault(require("react"));
const ImageUploaderIcon = _ref => {
  let {
    className,
    themeMode,
    isInvalid = false
  } = _ref;
  switch (themeMode) {
    case "ursa-light":
    case "ursa-dark":
      return /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "47",
        height: "58",
        fill: "none",
        className: className
      }, /*#__PURE__*/_react.default.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M33 1.5H1v52h27.215a11.476 11.476 0 0 1-.715-4C27.5 43.149 32.649 38 39 38c1.407 0 2.754.252 4 .715V11.5l-10-10Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_react.default.createElement("path", {
        stroke: "#5665A1",
        strokeLinecap: "round",
        strokeWidth: "1.4",
        d: "M43 37.95V12.443a3 3 0 0 0-.879-2.122L33.88 2.08a3 3 0 0 0-2.122-.88H4A3 3 0 0 0 1 4.2v46a3 3 0 0 0 3 3h23.75"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fill: "#D1D5E6",
        stroke: "#5665A1",
        strokeWidth: "1.4",
        d: "M32.4 1.2h.058a2.3 2.3 0 0 1 1.626.674l8.242 8.242A2.3 2.3 0 0 1 43 11.743v.057h-7.3a3.3 3.3 0 0 1-3.3-3.3V1.2Z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fill: "#B6BDD8",
        d: "m16 28.2-7.146 7.146a.5.5 0 0 0 .353.854H16l3.5-4.5-3.5-3.5Z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fill: "#DBDDEB",
        d: "M26 25.2 15.854 35.346a.5.5 0 0 0 .353.854h19.586a.5.5 0 0 0 .353-.854L26 25.2Z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        stroke: "#5665A1",
        strokeLinecap: "round",
        strokeWidth: "1.4",
        d: "m9 35.2 6.293-6.293a1 1 0 0 1 1.414 0L19.5 31.7m0 0L16 35.2m3.5-3.5 5.793-5.793a1 1 0 0 1 1.414 0L36 35.2"
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "18",
        cy: "22.2",
        r: "2",
        fill: "#A2ABCD"
      }), isInvalid ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "39",
        cy: "49.5",
        r: "8",
        fill: "#C21823"
      }), /*#__PURE__*/_react.default.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeWidth: "1.4",
        d: "m36.172 46.672 5.657 5.656M36.172 52.328l5.657-5.656"
      })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "39",
        cy: "49.5",
        r: "8",
        fill: "#1957DE"
      }), /*#__PURE__*/_react.default.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeWidth: "1.4",
        d: "M35 49.5h8M39 53.5v-8"
      })));
      break;
    case "lodestar-light":
    default:
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: "50",
        height: "40",
        viewBox: "0 0 50 40",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
      }, /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.774902",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.545761 6.19741L44.3663 6.21799C44.6677 6.21864 44.9119 6.4649 44.9126 6.76872L44.9274 39.4493C44.928 39.7533 44.6837 39.9999 44.3821 40C44.382 40 44.3818 40 44.3816 39.9995L0.561074 39.9789C0.259719 39.9783 0.0154572 39.732 0.0148154 39.4282L1.26015e-06 6.74763C-0.000640213 6.44361 0.243705 6.19704 0.545258 6.1969C0.545425 6.1969 0.545593 6.1969 0.545761 6.19741Z",
        fill: "#E1EBD6"
      }), /*#__PURE__*/_react.default.createElement("mask", {
        id: "mask0",
        "mask-type": "alpha",
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "0",
        width: "45",
        height: "35"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M49.454 0H6.24556C5.94401 0 5.69955 0.246457 5.69955 0.550477V33.7289C5.69955 34.0329 5.94401 34.2794 6.24556 34.2794H49.454C49.7555 34.2794 50 34.0329 50 33.7289V0.550477C50 0.246457 49.7555 0 49.454 0Z",
        fill: "white"
      })), /*#__PURE__*/_react.default.createElement("g", {
        mask: "url(#mask0)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        filter: "url(#filter0_d)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M49.454 0H6.24556C5.94401 0 5.69955 0.246457 5.69955 0.550477V33.7289C5.69955 34.0329 5.94401 34.2794 6.24556 34.2794H49.454C49.7555 34.2794 50 34.0329 50 33.7289V0.550477C50 0.246457 49.7555 0 49.454 0Z",
        fill: "black"
      })), /*#__PURE__*/_react.default.createElement("path", {
        d: "M49.454 0H6.24556C5.94401 0 5.69955 0.246457 5.69955 0.550477V33.7289C5.69955 34.0329 5.94401 34.2794 6.24556 34.2794H49.454C49.7555 34.2794 50 34.0329 50 33.7289V0.550477C50 0.246457 49.7555 0 49.454 0Z",
        fill: "white"
      }), /*#__PURE__*/_react.default.createElement("mask", {
        id: "mask1",
        "mask-type": "alpha",
        maskUnits: "userSpaceOnUse",
        x: "8",
        y: "3",
        width: "39",
        height: "28"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M46.2118 3.37079H9.48001C9.21065 3.37079 8.99229 3.59093 8.99229 3.86249V30.32C8.99229 30.5916 9.21065 30.8117 9.48001 30.8117H46.2118C46.4812 30.8117 46.6995 30.5916 46.6995 30.32V3.86249C46.6995 3.59093 46.4812 3.37079 46.2118 3.37079Z",
        fill: "white"
      })), /*#__PURE__*/_react.default.createElement("g", {
        mask: "url(#mask1)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M46.2118 3.37079H9.48001C9.21065 3.37079 8.99229 3.59093 8.99229 3.86249V30.32C8.99229 30.5916 9.21065 30.8117 9.48001 30.8117H46.2118C46.4812 30.8117 46.6995 30.5916 46.6995 30.32V3.86249C46.6995 3.59093 46.4812 3.37079 46.2118 3.37079Z",
        fill: "#E1EBD6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.4961 20.2619L32.33 34.5764L3.35199 31.481L15.4961 20.2619Z",
        fill: "#447E06"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.5136 15.3235C23.0567 15.3235 24.3076 14.0623 24.3076 12.5066C24.3076 10.9509 23.0567 9.6897 21.5136 9.6897C19.9705 9.6897 18.7195 10.9509 18.7195 12.5066C18.7195 14.0623 19.9705 15.3235 21.5136 15.3235Z",
        fill: "#E9AF26"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.8823 15.86L52.8595 32.29L11.8004 33.8977L34.8823 15.86Z",
        fill: "#70A13C"
      }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
        id: "filter0_d",
        x: "-3.30045",
        y: "-7",
        width: "62.3004",
        height: "52.2794",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, /*#__PURE__*/_react.default.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_react.default.createElement("feOffset", {
        dy: "2"
      }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
        stdDeviation: "4.5"
      }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.152941 0 0 0 0 0.337255 0 0 0 0 0 0 0 0 0.2 0"
      }), /*#__PURE__*/_react.default.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), /*#__PURE__*/_react.default.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
      }))));
  }
};
exports.ImageUploaderIcon = ImageUploaderIcon;
//# sourceMappingURL=ImageUploaderIcon.js.map